/* eslint-disable */
/**
 * This file was generated by TypeScriptGen v0.0.3
 * Any changes to this file will be lost if regenerated 
 */
import Axios, {AxiosResponse} from 'axios';
import {queryUrl, toFormData, defaultConfig, defaultFormConfig, contentOnly} from "./helper";
import LimeTemplate from "./LimeTemplate";
import LimeTemplateCreateResponse from "./LimeTemplateCreateResponse";
import LimeTemplateCreateRequest from "./LimeTemplateCreateRequest";
import LimePlayField from "./LimePlayField";
import LimeTemplateUpdateRequest from "./LimeTemplateUpdateRequest";
import IdRequest from "./IdRequest";
import PaginationResponse from "./PaginationResponse";
import LimeProductResponse from "./LimeProductResponse";
import PaginationRequestSearch from "./PaginationRequestSearch";
import LimeProductRequest from "./LimeProductRequest";
import IdActiveRequest from "./IdActiveRequest";
import LimeTemplateListResult from "./LimeTemplateListResult";
import SubmitApprovalRequest from "./SubmitApprovalRequest";
import LimeTemplateApprovalListItem from "./LimeTemplateApprovalListItem";
import DeclineApprovalRequest from "./DeclineApprovalRequest";
import LimeProgramResponse from "./LimeProgramResponse";
import LimeProgramCreateRequest from "./LimeProgramCreateRequest";
import LimeProgramUpdateRequest from "./LimeProgramUpdateRequest";
import LimeProgramListResult from "./LimeProgramListResult";
import LimeProgramApprovalListItem from "./LimeProgramApprovalListItem";
import FileContentResult from "./FileContentResult";
import LimeTemplateBasicResult from "./LimeTemplateBasicResult";
import LimeProductType from "./LimeProductType";
import LandResponse from "./LandResponse";
import LimingRegionResponse from "./LimingRegionResponse";
import LimingRegionRequest from "./LimingRegionRequest";

const urls = {
    get(id: number): string {
        return queryUrl("/lime/get", {id});
    },
    getPlayField(): string {
        return "/lime/getplayfield";
    },
    getProgram(id: number): string {
        return queryUrl("/lime/getprogram", {id});
    },
    getProgramPdf(id: number): string {
        return queryUrl("/lime/getprogrampdf", {id});
    },
    getProgramExcel(id: number): string {
        return queryUrl("/lime/getprogramexcel", {id});
    },
    getApprovedTemplates(): string {
        return "/lime/getapprovedtemplates";
    },
    getProductsByType(type: LimeProductType): string {
        return queryUrl("/lime/getproductsbytype", {type});
    },
    getAllProducts(): string {
        return "/lime/getallproducts";
    },
    getProductsByRegion(regionId: number): string {
        return queryUrl("/lime/getproductsbyregion", {regionId});
    },
    getFarmLands(farmId: number): string {
        return queryUrl("/lime/getfarmlands", {farmId});
    },
    getFarmLandsSync(farmId: number): string {
        return queryUrl("/lime/getfarmlandssync", {farmId});
    },
    getRegions(): string {
        return "/lime/getregions";
    }
}

export default {
    urls,
    get(id: number): Promise<LimeTemplate> {
        return contentOnly(Axios.get(queryUrl("/lime/get", {id}), defaultConfig));
    },
    create(request: LimeTemplateCreateRequest): Promise<LimeTemplateCreateResponse> {
        return contentOnly(Axios.post("/lime/create", request, defaultConfig));
    },
    getPlayField(): Promise<LimePlayField> {
        return contentOnly(Axios.get("/lime/getplayfield", defaultConfig));
    },
    update(request: LimeTemplateUpdateRequest): Promise<void> {
        return contentOnly(Axios.post("/lime/update", request, defaultConfig));
    },
    removeTemplate(request: IdRequest): Promise<boolean> {
        return contentOnly(Axios.post("/lime/removetemplate", request, defaultConfig));
    },
    productsPaged(request: PaginationRequestSearch): Promise<PaginationResponse<LimeProductResponse>> {
        return contentOnly(Axios.post("/lime/productspaged", request, defaultConfig));
    },
    productUpsert(request: LimeProductRequest): Promise<boolean> {
        return contentOnly(Axios.post("/lime/productupsert", request, defaultConfig));
    },
    productToggleActive(request: IdActiveRequest): Promise<boolean> {
        return contentOnly(Axios.post("/lime/producttoggleactive", request, defaultConfig));
    },
    templatesPaged(request: PaginationRequestSearch): Promise<PaginationResponse<LimeTemplateListResult>> {
        return contentOnly(Axios.post("/lime/templatespaged", request, defaultConfig));
    },
    submitTemplate(request: SubmitApprovalRequest): Promise<boolean> {
        return contentOnly(Axios.post("/lime/submittemplate", request, defaultConfig));
    },
    templateApprovals(request: PaginationRequestSearch): Promise<PaginationResponse<LimeTemplateApprovalListItem>> {
        return contentOnly(Axios.post("/lime/templateapprovals", request, defaultConfig));
    },
    approveTemplate(request: IdRequest): Promise<boolean> {
        return contentOnly(Axios.post("/lime/approvetemplate", request, defaultConfig));
    },
    declineTemplate(request: DeclineApprovalRequest): Promise<boolean> {
        return contentOnly(Axios.post("/lime/declinetemplate", request, defaultConfig));
    },
    getProgram(id: number): Promise<LimeProgramResponse> {
        return contentOnly(Axios.get(queryUrl("/lime/getprogram", {id}), defaultConfig));
    },
    createProgram(request: LimeProgramCreateRequest): Promise<number> {
        return contentOnly(Axios.post("/lime/createprogram", request, defaultConfig));
    },
    updateProgram(request: LimeProgramUpdateRequest): Promise<void> {
        return contentOnly(Axios.post("/lime/updateprogram", request, defaultConfig));
    },
    archiveProgram(request: IdRequest): Promise<boolean> {
        return contentOnly(Axios.post("/lime/archiveprogram", request, defaultConfig));
    },
    restoreProgram(request: IdRequest): Promise<boolean> {
        return contentOnly(Axios.post("/lime/restoreprogram", request, defaultConfig));
    },
    programsPaged(request: PaginationRequestSearch): Promise<PaginationResponse<LimeProgramListResult>> {
        return contentOnly(Axios.post("/lime/programspaged", request, defaultConfig));
    },
    programArchives(request: PaginationRequestSearch): Promise<PaginationResponse<LimeProgramListResult>> {
        return contentOnly(Axios.post("/lime/programarchives", request, defaultConfig));
    },
    submitProgram(request: SubmitApprovalRequest): Promise<boolean> {
        return contentOnly(Axios.post("/lime/submitprogram", request, defaultConfig));
    },
    finishProgram(id: number): Promise<boolean> {
        return contentOnly(Axios.post("/lime/finishprogram", id, defaultConfig));
    },
    programApprovals(request: PaginationRequestSearch): Promise<PaginationResponse<LimeProgramApprovalListItem>> {
        return contentOnly(Axios.post("/lime/programapprovals", request, defaultConfig));
    },
    approveProgram(request: IdRequest): Promise<boolean> {
        return contentOnly(Axios.post("/lime/approveprogram", request, defaultConfig));
    },
    declineProgram(request: DeclineApprovalRequest): Promise<boolean> {
        return contentOnly(Axios.post("/lime/declineprogram", request, defaultConfig));
    },
    getProgramPdf(id: number): Promise<FileContentResult> {
        return contentOnly(Axios.get(queryUrl("/lime/getprogrampdf", {id}), defaultConfig));
    },
    getProgramExcel(id: number): Promise<FileContentResult> {
        return contentOnly(Axios.get(queryUrl("/lime/getprogramexcel", {id}), defaultConfig));
    },
    getApprovedTemplates(): Promise<LimeTemplateBasicResult[]> {
        return contentOnly(Axios.get("/lime/getapprovedtemplates", defaultConfig));
    },
    getProductsByType(type: LimeProductType): Promise<LimeProductResponse[]> {
        return contentOnly(Axios.get(queryUrl("/lime/getproductsbytype", {type}), defaultConfig));
    },
    getAllProducts(): Promise<LimeProductResponse[]> {
        return contentOnly(Axios.get("/lime/getallproducts", defaultConfig));
    },
    getProductsByRegion(regionId: number): Promise<LimeProductResponse[]> {
        return contentOnly(Axios.get(queryUrl("/lime/getproductsbyregion", {regionId}), defaultConfig));
    },
    getFarmLands(farmId: number): Promise<LandResponse[]> {
        return contentOnly(Axios.get(queryUrl("/lime/getfarmlands", {farmId}), defaultConfig));
    },
    getFarmLandsSync(farmId: number): Promise<LandResponse[]> {
        return contentOnly(Axios.get(queryUrl("/lime/getfarmlandssync", {farmId}), defaultConfig));
    },
    getRegions(): Promise<LimingRegionResponse[]> {
        return contentOnly(Axios.get("/lime/getregions", defaultConfig));
    },
    regionsPaged(request: PaginationRequestSearch): Promise<PaginationResponse<LimingRegionResponse>> {
        return contentOnly(Axios.post("/lime/regionspaged", request, defaultConfig));
    },
    regionUpsert(request: LimingRegionRequest): Promise<boolean> {
        return contentOnly(Axios.post("/lime/regionupsert", request, defaultConfig));
    }
}
